import { Button, Icon, IconButton, Modal, ModalContent } from '@toctoc/design-system';
import { QuoteStatusModalProps } from './QuoteStatusModal.interface'
import styles from './QuoteStatusModal.module.scss';
import { ePropertyCondition } from '@/app/globalContext/globalContext.interfaces';
import { useEffect } from 'react';

const cloudfrontUrl = process.env.NEXT_PUBLIC_CLOUDFRONT_IMG || '';
const FALLBACK_IMG = `${cloudfrontUrl}listaseo/img/imagen-no-viene-cards-vertical.png`;

export const QuoteStatusModal = (props: QuoteStatusModalProps) => {
	const { showModal, isMobile, quoteStatusModalHandler, selectedPropertyData, leadStatusInfo, isItau } = props ?? {};
	const { tipoPropiedad, idEstadoPropiedad, tipoOperacion, comuna, titulo, precios, imagenInmobiliaria } = selectedPropertyData ?? {};
	const { src: imagenInmobiliariaSrc } = imagenInmobiliaria ?? {};
	const { success, message } = leadStatusInfo ?? {};

	const closeHandler = () => {
		quoteStatusModalHandler(false);
	}

	useEffect(() => {
		if (!showModal) return;
		setTimeout(() => {
			if (showModal) {
				quoteStatusModalHandler(false);
			}
		}, 5000)
	}, [showModal]);

	return (
		<Modal open={showModal} claseAux={styles.quoteStatusModal} handleClose={closeHandler} maxWidth='xl'>
			<ModalContent>
				{success ? <div className={styles.mainC}>
					<section className={styles.closeButtonC}>
						<span><strong>Cotización exitosa</strong></span>
						<IconButton className='btn-cerrar-modal' onClick={closeHandler}>
							<Icon name='close' size={isMobile ? 16 : 24} color='#343A40'/>
						</IconButton>
					</section>
					<section className={styles.propertyDetails}>
						{!isMobile && <div className={styles.imageC}>
							<img
								src={imagenInmobiliariaSrc || FALLBACK_IMG}
								onError={(e) => { (e.currentTarget as HTMLImageElement).src = FALLBACK_IMG }}
							/>
						</div>}
						<div className={styles.propertyInfo}>
							<div className={styles.description}>
								<h3>{tipoPropiedad} <span>{`${idEstadoPropiedad === ePropertyCondition.new ? (tipoPropiedad.toLowerCase().endsWith('a') ? 'nueva' : 'nuevo') : (tipoPropiedad.toLowerCase().endsWith('a') ? 'usada' : 'usado')} en ${tipoOperacion.toLowerCase().includes('venta') ? 'venta' : 'arriendo'} en ${comuna}`}</span></h3>
							</div>
							<div className={styles.title}>
								<strong>{titulo}</strong>
							</div>
						</div>
						{!isMobile && <div className={styles.separator}/>}
						<div className={styles.price}>
							{isMobile ? 'Precio ref. unidad' : 'Precio referencial'}
							<strong>{precios[0]?.prefix} {precios[0]?.value}</strong>
							<span>{precios[1]?.prefix} {precios[1]?.value}</span>
						</div>
					</section>
					<section className={styles.disclaimer}>
						<div className={styles.IconC}>
							<Icon name='check-circle' size={isMobile ? 16 : 24} color='#23AD63' />
						</div>
						<p>{isItau ? 'Itaú y la inmobiliaria se contactarán' : 'La inmobiliaria se contactará'} contigo para coordinar una visita al proyecto. <strong>Si esto no ocurre en un plazo de 48 horas,</strong> sugerimos que te contactes directamente con la sala de ventas o inmobiliaria.</p>
					</section>
				</div>
					: <div className={styles.mainC}>
						<section className={styles.closeButtonErrorC}>
							<IconButton className='btn-cerrar-modal' onClick={closeHandler}>
								<Icon name='close' size={isMobile ? 16 : 24} color='#343A40'/>
							</IconButton>
						</section>
						<section className={styles.modalBodyC}>
							<div className={styles.IconC}>
								<Icon name='SmileySad' size={isMobile ? 48 : 72} color='#E63946' />
							</div>
							<div className={styles.title}>
								<span><strong>¡Lo sentimos!</strong></span>
								<span><strong>No se pudo realizar la cotización</strong></span>
							</div>
							<div className={styles.description}>
								<span>{message}</span>
							</div>
						</section>
						<section className={styles.buttonC}>
							<Button size='small' texto='Aceptar' variant='text' style={{ fontSize: '16px' }} onClick={closeHandler} />
						</section>
					</div>}
			</ModalContent>
		</Modal>
	)
}